import React, {useState} from 'react';

import styles from '../styles.module.scss';
import antiWebhookFeature from './AntiWebhookFeature.module.scss';
import {Time, Webhook1, Webhook2, Webhook3, Webhook4} from '../../../assets';

const data = [
  {
    id: '1',
    name: 'Spidey Bot',
    avatar: <Webhook1 />,
    icon: <Time />,
    date: 'Created on 12 Nov 2023 by the_koi',
  },
  {
    id: '2',
    name: 'Capitan Hook',
    avatar: <Webhook2 />,
    icon: <Time />,
    date: 'Created on 12 Nov 2023 by the_koi',
  },
  {
    id: '3',
    name: 'Capitan Hook',
    avatar: <Webhook3 />,
    icon: <Time />,
    date: 'Created on 12 Nov 2023 by the_koi',
  },
  {
    id: '4',
    name: 'Spidey Bot',
    avatar: <Webhook4 />,
    icon: <Time />,
    date: 'Created on 12 Nov 2023 by the_koi',
  },
];

export const AntiWebhookFeature = () => {
  const [list, setList] = useState(data);

  const addWebhook = () => {
    return setList((prev) => [
      {
        id: prev.length + 1,
        name: 'Capitan Hook',
        avatar: <Webhook2 />,
        icon: <Time />,
        date: 'Created on 12 Nov 2023 by the_koi',
      },
      ...prev,
    ]);
  };

  return (
    <div className={antiWebhookFeature.wrapper}>
      <div className={styles.button} onClick={addWebhook}>
        New Webhook
      </div>
      <div className={antiWebhookFeature.tag}>
        Posting to <span className={antiWebhookFeature.tagMod}>#Announcements</span>
      </div>
      <div className={antiWebhookFeature.wrapperData}>
        {list.map((item) => (
          <Item key={item.id} data={item} />
        ))}
      </div>
    </div>
  );
};

const Item = ({data}) => {
  return (
    <div className={antiWebhookFeature.item}>
      <div className={antiWebhookFeature.itemInner}>
        <div className={antiWebhookFeature.avatar}>{data.avatar}</div>
        <div className={antiWebhookFeature.right}>
          <div className={antiWebhookFeature.name}>{data.name}</div>
          <div className={antiWebhookFeature.info}>
            <div className={antiWebhookFeature.icon}>{data.icon}</div>
            <div className={antiWebhookFeature.date}>{data.date}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
